import Icon from '@/components/UI/Icon';
import type { ID } from '@/model/Common.model';
import { _isNil } from '@/littledash';
import { FC } from 'react';

interface ExpandableIconProps {
  itemId?: ID;
  isExpandable: boolean;
  isExpanded?: boolean;
  onToggle: (itemId: ID) => void;
  testIdPrefix?: string;
}

export const ExpandableIcon: FC<ExpandableIconProps> = ({
  itemId,
  isExpandable,
  isExpanded = false,
  onToggle,
  testIdPrefix = 'field',
}) => {
  if (!isExpandable || _isNil(itemId)) {
    return null;
  }

  return (
    <Icon
      icon={isExpanded ? 'chev_up' : 'chev_down'}
      className="dib mid-gray pointer"
      width="14"
      height="14"
      onClick={() => onToggle(itemId)}
      data-testid={`expand-icon-${testIdPrefix}`}
    />
  );
};
